// @ts-nocheck
import { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";
import { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import { CartLineQuantityStyles } from "@insite/content-library/Widgets/Cart/CartLineQuantity";
import { GridContainerProps } from "@insite/mobius/GridContainer";
// import { GridItemProps } from "@insite/mobius/GridItem"; // Foundation
import { IconPresentationProps } from "@insite/mobius/Icon";
import Eye from "@insite/mobius/Icons/Eye";
import EyeOff from "@insite/mobius/Icons/EyeOff";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldPresentationProps } from "@insite/mobius/TextField";
import { TypographyPresentationProps, TypographyProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
import { CheckboxPresentationProps } from "@store/MobiusOverrides/Checkbox/Checkbox";
import { FormFieldPresentationProps } from "@store/MobiusOverrides/FormField/FormField";
import { ProductAvailabilityStyles } from "@store/Overrides/Components/ProductAvailability";
import { ProductImageStyles } from "@store/Overrides/Components/ProductImage";
import { ProductPriceStyles } from "@store/Overrides/Components/ProductPrice";
// import {
//     priceSecondarySpacingStyles,
//     priceStyles,
//     priceUnitOfMeasureStyles,
//     priceVatLabelStyles,
// } from "@store/Themes/common/mixins/price";  // Foundation
import { inlineSeparatorStyles } from "@store/Themes/common/mixins/typography";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem, pxToRemArray } from "@toolkit/Framework/Common/Utilities/unitHelper";
import EditFill from "@toolkit/Library/Components/Icons/Edit/EditFill";
import LogOut from "@toolkit/Library/Components/Icons/LogOut";
import PlusCircleFill from "@toolkit/Library/Components/Icons/PlusCircle/PlusCircleFill";
import TrashFill from "@toolkit/Library/Components/Icons/Trash/TrashFill";
import { gridGapStyles, spacingStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

// Foundation --->
import { BreakpointType, hiddenStyles } from "@store/Themes/common/mixins/common";
import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridItemProps, GridWidths } from "@insite/mobius/GridItem";
import { TextFieldProps } from "@insite/mobius/TextField";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import {
    priceSecondarySpacingStyles,
    priceStyles,
    priceUnitOfMeasureStyles,
    priceVatLabelStyles,
} from "@store/Themes/common/mixins/price";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import Close from "@toolkit/Library/Components/Icons/Close";
// <--- Foundation

export interface ProductLineProps {
    spacer?: InjectableCss;
    container?: GridContainerProps;
    messageGridItem?: GridItemProps;
    messageInfosBox?: InfosBoxProps;
    sortSelectGridItem?: GridItemProps;
    selectedCheckbox?: CheckboxPresentationProps;
    imageGridItem?: GridItemProps;
    image?: ProductImageStyles;
    removeLink?: LinkPresentationProps;
    editNotesLink: LinkPresentationProps;
    addNotesLink: LinkPresentationProps;
    addToCartLink?: LinkPresentationProps;
    addToListLink?: LinkPresentationProps;
    leaveListLink?: LinkPresentationProps;
    hideListLink?: LinkPresentationProps;
    unhideListLink?: LinkPresentationProps;
    viewReplacementLink?: LinkPresentationProps;
    contentGridItem?: GridItemProps;
    contentContainer?: GridContainerProps;
    infoGridItem?: GridItemProps;
    infoContainer?: GridContainerProps;
    descriptionGridItem?: GridItemProps;
    brand?: ProductBrandStyles;
    description?: ProductDescriptionStyles;
    partNumbersGridItem?: GridItemProps;
    partNumbers?: ProductPartNumbersStyles;
    configurationGridItem?: GridItemProps;
    configuration?: TypographyProps;
    availabilityGridItem?: GridItemProps;
    availability?: ProductAvailabilityStyles;
    swatchGridItem?: GridItemProps;
    badgesGridItem?: GridItemProps;
    deliveryScheduleGridItem?: GridItemProps;
    deliveryScheduleLink?: LinkPresentationProps;
    costCodeGridItem?: GridItemProps;
    costCodeLabel?: TypographyPresentationProps;
    costCodeSelect?: SelectPresentationProps;
    costCodeText?: TypographyPresentationProps;
    pricingGridItem?: GridItemProps;
    pricingContainer?: GridContainerProps;
    priceGridItem?: GridItemProps;
    price?: ProductPriceStyles;
    savedPrice?: {
        label?: TypographyPresentationProps;
        wrapper?: InjectableCss;
        unitOfMeasure?: TypographyPresentationProps;
        secondaryWrapper?: InjectableCss;
    };
    promotion?: TypographyProps;
    unitOfMeasureGridItem?: GridItemProps;
    unitOfMeasureContainer?: GridContainerProps;
    unitOfMeasureFieldGridItem?: GridItemProps;
    unitOfMeasureQuantityFieldGridItem?: GridItemProps;
    quantityGridItem?: GridItemProps;
    quantity?: CartLineQuantityStyles;
    subtotalGridItem?: GridItemProps;
    subtotalLabel?: TypographyPresentationProps;
    subtotalValue?: TypographyPresentationProps;
    subtotalSecondValue?: TypographyPresentationProps;
    subtotalVatLabel?: TypographyPresentationProps;
    notesWrapper?: InjectableCss;
    textField?: FormFieldPresentationProps<any>;
    // Foundation
    removeProductLineIcon?: IconPresentationProps;
}

const descriptionTypographyProps: TypographyPresentationProps = {
    forwardAs: "h3",
    css: css`
        ${({ theme }) => css`
            font-size: ${theme.design.typography.size.large};
            font-weight: ${theme.design.typography.weight.bold};
            line-height: ${theme.design.typography.lineHeight.semi};
        `}
    `,
};

const getLinkProps = (src?: IconPresentationProps["src"]) => {
    const spacing = pxToRem(6);

    return mergeProps<LinkPresentationProps>(linkGetActionLinkProps(src), {
        css: css`
            ${spacingStyles(spacing, spacing)}
            display: flex;
        `,
    });
};

const fullGridItemProps: GridItemProps = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

const subtotalValue: TypographyPresentationProps = {
    css: css`
        ${priceStyles()}
        font-weight: ${x => x.theme.design.typography.weight.bold};
    `,
};

const textFieldProps: TextFieldPresentationProps = {
    labelProps: {
        variant: "legend",
        css: css`
            ${x => x.theme.typography.legend.css}
        `,
    },
    sizeVariant: "small",
    cssOverrides: {
        formInputWrapper: css`
            ${x => x.theme.formField.defaultProps?.cssOverrides?.formInputWrapper}
            margin-top: ${pxToRem(3)} !important;
        `,
        inputSelect: css`
            ${x => x.theme.formField.defaultProps?.cssOverrides?.inputSelect}
        `,
    },
};

const borderWidth = pxToRem(1);

export const productLineProps: ProductLineProps = {
    spacer: {
        css: css`
            height: ${borderWidth};
        `,
    },
    container: {
        gap: 0,
        css: css`
            ${x => gridGapStyles(pxToRemArray([20]), [x.theme.design.typography.spacing.base])}
            position: relative;
            padding: ${pxToRem(22, 0)};
            border-top: ${borderWidth} solid ${getColor("common.border")};
            border-bottom: ${borderWidth} solid ${getColor("common.border")};
            word-break: break-word;
            background-color: ${getColor("common.background")};
            margin-top: -${borderWidth};

            &:first-child {
                padding-top: 0;
                border-top: 0;
                margin-top: 0;
            }

            :not(body > &) &:last-child {
                padding-bottom: 0;
                border-bottom: 0;
            }

            body > & /* Dragging ProductLine */ {
                z-index: 2;
                height: auto !important;
                box-shadow: ${x => x.theme.shadows.dragVertical};
            }
        `,
    },
    messageGridItem: {
        width: 12,
        css: css`
            flex-direction: column;
        `,
    },
    messageInfosBox: {
        size: "small",
        type: "warning",
        extendedStyles: {
            wrapper: {
                css: spacingStyles(pxToRem(1), pxToRem(1)),
            },
        },
    },
    sortSelectGridItem: { width: 12 },
    selectedCheckbox: {
        sizeVariant: "small",
        css: css`
            ${x => x.theme.checkbox.defaultProps?.css as any}
            cursor: pointer;
            ${inlineSeparatorStyles(pxToRem(23), pxToRem(1), "common.border")}

            @media print {
                display: none;
            }
        `,
    },
    imageGridItem: {
        width: [4, 3, 3, 2, 2],
        printWidth: 2,
        css: css`
            display: block;
        `,
    },
    image: {
        linkWrappingImage: {
            css: css`
                max-height: ${pxToRem(100)};
            `,
        },
        wrapper: {
            css: spacingStyles(null, pxToRem(12)),
        },
    },
    addToCartLink: getLinkProps(PlusCircleFill),
    removeLink: getLinkProps(TrashFill),
    addToListLink: getLinkProps(PlusCircleFill),
    leaveListLink: getLinkProps(LogOut),
    hideListLink: getLinkProps(EyeOff),
    unhideListLink: getLinkProps(Eye),
    editNotesLink: getLinkProps(EditFill),
    addNotesLink: getLinkProps(EditFill),
    viewReplacementLink: getLinkProps(),
    contentGridItem: {
        width: [8, 9, 9, 10, 10],
        printWidth: 10,
        css: css`
            flex-direction: column;
        `,
    },
    contentContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles(pxToRemArray([16]), pxToRemArray([12]))}
        `,
    },
    infoGridItem: {
        width: [12, 12, 12, 12, 6],
        printWidth: 6,
    },
    infoContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles([], pxToRemArray([8]))}
        `,
    },
    descriptionGridItem: fullGridItemProps,
    brand: {
        nameText: {
            color: "text.main",
            css: css`
                font-size: ${x => x.theme.design.typography.size.smallest};
                font-weight: ${x => x.theme.design.typography.weight.base};
                text-transform: uppercase;
            `,
        },
    },
    description: {
        productDetailLink: {
            typographyProps: descriptionTypographyProps,
        },
        productDetailDescription: descriptionTypographyProps,
    },
    partNumbersGridItem: fullGridItemProps,
    partNumbers: {
        container: {
            gap: 0,
            css: css`
                ${gridGapStyles([], [pxToRem(3)])}
                font-size: ${x => x.theme.design.typography.size.smaller};
                line-height: ${x => x.theme.design.typography.lineHeight.small};
            `,
        },
    },
    configurationGridItem: fullGridItemProps,
    configuration: {
        color: "text.accent",
        forwardAs: "p",
        css: css`
            ${spacingStyles(null, pxToRem(3))}
            font-size: ${x => x.theme.design.typography.size.smaller};
            line-height: ${x => x.theme.design.typography.lineHeight.small};
        `,
    },
    availabilityGridItem: fullGridItemProps,
    availability: {},
    swatchGridItem: fullGridItemProps,
    badgesGridItem: {
        width: [12, 12, 12, 8, 12],
        css: fullGridItemProps.css,
    },
    deliveryScheduleGridItem: fullGridItemProps,
    deliveryScheduleLink: {},
    costCodeGridItem: fullGridItemProps,
    costCodeLabel: {
        variant: "legend",
    },
    costCodeSelect: {
        sizeVariant: "small",
    },
    costCodeText: {
        css: css`
            line-height: ${x => x.theme.design.typography.lineHeight.semi};
        `,
    },
    pricingGridItem: {
        width: [12, 12, 12, 12, 6],
        printWidth: 6,
    },
    pricingContainer: {
        gap: 0,
        css: css`
            ${gridGapStyles([pxToRem(16)], [pxToRem(8)])}
        `,
    },
    priceGridItem: {
        width: [12, 5, 5, 5, 5],
        printWidth: 5,
        css: css`
            flex-direction: column;
        `,
    },
    price: {
        priceLabelText: {
            variant: "legend",
        },
        wrapper: {
            css: css`
                font-weight: ${x => x.theme.design.typography.weight.base};
            `,
        },
        price: {
            saleLabelText: {
                css: css`
                    display: block;
                    font-size: ${x => x.theme.design.typography.size.smaller};
                `,
            },
        },
    },
    savedPrice: {
        label: {
            variant: "legend",
            css: css`
                display: block;
            `,
        },
        wrapper: {
            css: priceStyles(),
        },
        secondaryWrapper: {
            css: css`
                ${priceStyles()}
                ${priceSecondarySpacingStyles()}
            `,
        },
        unitOfMeasure: {
            css: priceUnitOfMeasureStyles(),
        },
    },
    promotion: {
        italic: true,
        color: "text.accent",
        forwardAs: "p",
        css: css`
            font-size: ${x => x.theme.design.typography.size.tiny};
            line-height: ${x => x.theme.design.typography.lineHeight.small};
            ${spacingStyles(null, pxToRem(3))}
        `,
    },
    unitOfMeasureGridItem: { width: [12, 7, 7, 7, 7], printWidth: 7 },
    unitOfMeasureContainer: { gap: 10 },
    unitOfMeasureFieldGridItem: { width: [12, 8, 8, 8, 8], printWidth: 6 },
    unitOfMeasureQuantityFieldGridItem: {
        width: [12, 4, 4, 4, 4],
        printWidth: 6,
        css: css`
            flex-direction: column;
        `,
    },
    quantityGridItem: {
        width: [4, 3, 3, 3, 3],
    },
    quantity: {
        editableQuantityTextField: mergeProps<CartLineQuantityStyles["editableQuantityTextField"]>(textFieldProps, {
            cssOverrides: {
                inputSelect: css`
                    width: ${pxToRem(55)};
                `,
            },
        }),
    },
    subtotalGridItem: {
        width: [8, 4, 4, 4, 4],
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    subtotalLabel: {
        variant: "legend",
        css: css`
            display: block;
        `,
    },
    subtotalValue,
    subtotalSecondValue: {
        ...subtotalValue,
        css: css`
            ${subtotalValue?.css}
            ${priceSecondarySpacingStyles()}
        `,
    },
    subtotalVatLabel: {
        css: priceVatLabelStyles(),
    },
    notesWrapper: {
        css: css`
            width: 100%;
            ${spacingStyles(pxToRem(12), null)}
        `,
    },
    textField: textFieldProps,
    // Foundation --->
    removeProductLineIcon: {
        src: Close,
        size: 16,
        color: "text.main",
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: ${pxToRem(36)};
            height: ${pxToRem(36)};
            border-radius: 50%;
            background-color: ${getColor("common.accent")};
            transition: ${transitionHoverStyles("color")};

            &:hover {
                background-color: ${getColor("common.border")};
            }
        `,
        // <--- Foundation
    },
};

// Foundation - OLD VERSION--->

export interface ProductLinePropsAlt {
    wrapper?: InjectableCss;
    container?: GridContainerProps;
    productGridItem?: GridItemProps;
    productControlsGridItem?: GridItemProps;
    productImage?: ProductImageStyles;
    productInfosWrapper?: InjectableCss;
    productControls?: InjectableCss;
    productControlsItem?: InjectableCss;
    productDescription?: ProductDescriptionStyles;
    productPrice?: ProductPriceStyles;
    extendedUnitNetPriceText?: TypographyPresentationProps;
    quantityOrdered?: TextFieldProps;
    mobileProductControls?: InjectableCss;
    removeProductLineIcon?: IconPresentationProps;
    removeProductButton?: ClickablePresentationProps;
    productLineProductWidth?: GridWidths | GridWidths[];
    productLineControlsWidth?: GridWidths | GridWidths[];
    productAvailability?: ProductAvailabilityStyles;
    quantity?: CartLineQuantityStyles;
    notesWrapper?: InjectableCss;
}

export const productLinePropsAlt: ProductLinePropsAlt = {
    wrapper: {
        css: css`
            display: flex;
            padding: 1rem 0;
            border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            align-items: flex-start;
                        `,
                        null,
                        null,
                        css`
                            align-items: center;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    container: {
        gap: 20,
        offsetCss: css`
            width: 100% !important; /* Need this to fix the variable width of the gridOffset */
        `,
    },
    productGridItem: {
        width: [12, 12, 12, 5, 5],
        align: "top",
        css: css`
            @media print {
                width: 100% !important;
                display: flex !important;
            }
        `,
    },
    productControlsGridItem: {
        width: 7,
        align: "middle",
        css: css`
            @media print {
                display: none !important;
            }
        `,
    },
    mobileProductControls: {
        css: css`
            width: 100%;
            ${hiddenStyles(BreakpointType.Above, "lg")}
        `,
    },
    productControls: {
        css: css`
            display: flex;
            align-items: center;
            width: 100%;
        `,
    },
    productControlsItem: {
        css: css`
            display: flex;
            align-items: center;
            width: calc(100% / 4);
            margin: 0.5em 0;
        `,
    },
    productImage: {
        linkWrappingImage: {
            css: css`
                width: auto;

                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                min-width: 100%;
                                max-width: ${pxToRem(90)};
                                margin-right: ${pxToRem(10)};
                            `,
                            css`
                                margin-right: ${pxToRem(30)};
                            `,
                            css`
                                min-width: 100%;
                                max-width: ${pxToRem(115)};
                                margin-right: ${pxToRem(35)};
                            `,
                        ],
                        mediaOptions.min,
                    )}
            `,
        },
    },
    productInfosWrapper: {
        css: css`
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            gap: ${pxToRem(8)};

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        css`
                            width: 75%;
                            padding-right: ${pxToRem(24)};
                        `,
                        null,
                        css`
                            width: 100%;
                            padding-right: ${pxToRem(24)};
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    productDescription: {
        productDetailLink: {
            color: "primary",
            css: css`
                ${contentSpacingStyles(0, 0, pxToRem(7))}
            `,
        },
        productDetailDescription: {
            color: "primary",
            css: css`
                ${contentSpacingStyles(0, 0, pxToRem(7))}
            `,
        },
    },
    productPrice: {
        wrapper: {
            css: css`
                ${contentSpacingStyles(pxToRem(5), 0, 0)}
            `,
        },
        price: {
            priceText: {
                color: "text.dark",
                css: css`
                    font-size: ${({ theme }) => theme.design.typography.size.base};
                    font-weight: ${({ theme }) => theme.design.typography.weight.medium};
                `,
            },
        },
    },
    extendedUnitNetPriceText: {
        color: "primary",
        css: css`
            font-size: ${({ theme }) => theme.design.typography.size.base};
            font-weight: ${({ theme }) => theme.design.typography.weight.bold};
        `,
    },
    quantityOrdered: {
        css: css`
            text-align: center;
        `,
        cssOverrides: {
            formInputWrapper: css`
                max-width: ${pxToRem(65)};
            `,
            formField: css`
                margin-right: ${pxToRem(25)};
                max-width: ${pxToRem(65)};
            `,
        },
    },
    removeProductLineIcon: {
        src: Close,
        size: 16,
        color: "text.main",
        css: css`
            display: flex;
            align-items: center;
            justify-content: center;
            width: ${pxToRem(36)};
            height: ${pxToRem(36)};
            border-radius: 50%;
            background-color: ${getColor("common.accent")};
            transition: ${transitionHoverStyles("color")};

            &:hover {
                background-color: ${getColor("common.border")};
            }
        `,
    },
    removeProductButton: {
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        margin: auto 0;
                    `,
                    css`
                        margin: auto 0;
                    `,
                ])}
        `,
    },
    productLineProductWidth: [12, 12, 12, 6, 6],
    productLineControlsWidth: 6,
    productAvailability: {
        messageGridItem: {
            css: css`
                ${breakpointValues([".5em", null, null, "0"], "padding-top")}
            `,
        },
        messageText: {
            css: css`
                ${breakpointValues(["nowrap", null, null, "normal"], ["white-space"])}
            `,
        },
    },
    notesWrapper: {
        css: css`
            width: 100%;
            ${contentSpacingStyles(pxToRem(12), null, null)}
        `,
    },
};
// <--- Foundation
